<template>
  <div class="row mt-2">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'coachBillingExistedBills'}"
              :class="{ active: $route.name === 'coachBillingExistedBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{ $t('external_coach_billing.bills_created') }}
          </router-link>
          <router-link
              :to="{ name: 'coachBillingPendingBills'}"
              :class="{ active: $route.name === 'coachBillingPendingBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{ $t('external_coach_billing.pending_bills') }}
            <span v-if="countUnreadMessagesForAccountant > 0"
                  style="
                      position:absolute;
                      top:0;
                      right: 0;
                      font-size: 8px;
                      padding: 3px 8px;
                      background-color: #DC3545FF;
                      color: white;
                      border-radius: 11px;">!</span>
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
      countUnreadMessagesForAccountant: {
        type: Number,
        required: true,
      },
    },
);

const countUnreadMessagesForAccountant = toRefs(props)[ 'countUnreadMessagesForAccountant' ];

</script>

<style scoped>

</style>